var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcViewArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "13px",
    viewBox: "0 0 21 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_view_arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winds-Webapp",
    transform: "translate(-289.000000, -662.000000)",
    fill: "#6372FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(252.000000, 574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5,87 C55.0898509,87 58,89.9101491 58,93.5 C58,97.0898509 55.0898509,100 51.5,100 L43.5,100 C39.9101491,100 37,97.0898509 37,93.5 C37,89.9101491 39.9101491,87 43.5,87 L51.5,87 Z M49.2397194,89.7507308 C49.0182147,89.5497564 48.6802244,89.5497564 48.4587197,89.7507308 C48.2210581,89.9662836 48.2030771,90.3333483 48.4188488,90.5707688 L50.702,92.844 L42.8584,92.8448 C42.52239,92.8448 42.25,93.11719 42.25,93.4532 C42.25,93.78921 42.52239,94.0616 42.8584,94.0616 L50.775,94.061 L48.4188488,96.4073568 C48.1921322,96.6359261 48.1939563,97.004813 48.4227577,97.2312997 C48.6515591,97.4577864 49.0208206,97.4559641 49.2475372,97.2273948 L52.5883503,93.8977801 C52.6936302,93.7879211 52.7517426,93.6410952 52.7499602,93.4890628 L52.7439441,93.3987222 C52.726611,93.2797787 52.6725742,93.1682327 52.5883503,93.0803454 Z",
    id: "ic_view_arrow"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewArrow);
export default __webpack_public_path__ + "static/media/ic_view_arrow.85edf070c4532e97b0a9e7bb7d982f5b.svg";
export { ForwardRef as ReactComponent };